<mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title><h2>Subscripciones</h2></mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div id="fieldsContainer">
        <mat-accordion class="iconTitle" multi>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon>find_in_page</mat-icon>Busqueda Avanzada
              </mat-panel-title>
            </mat-expansion-panel-header>
            <br>
            <div id="container" class="formControl">
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Nombre</mat-label>
                  <input matInput>
                  <mat-icon matSuffix>person</mat-icon>
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>RFC</mat-label>
                  <input matInput>
                  <mat-icon matSuffix>document_scanner</mat-icon>
                </mat-form-field>
              </div>
            </div>
            <div id="buttonContainer">
              <button mat-flat-button class="button">
                <mat-icon>search</mat-icon>Consultar
              </button>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
      <br>
      <div id="tableContainer">
        <app-table #subscriptionTable  
                    (paginatorEvent)="paginatorEvent($event)"
                    (editEvent)="editEvent($event)"
                    (deleteEvent)="deleteEvent($event)"
                    [tableModel]="tableModel">
        </app-table>
      </div>
    </mat-card-content>
  </mat-card>